<template>
  <div
    class="notification-elem-list"
    :class="{
      viewed: viewed,
      selectedNoti: selectedNotification,
    }"
    :style="{
      borderColor: colorOnHeader ? colorOnHeader : 'lightgrey',
    }"
    @click.stop.left.exact="redirecToAction"
    @click.stop.middle.exact="redirecToActionNewWindow"
    @click.stop.ctrl.exact="redirecToActionNewWindow"
  >
    <v-checkbox
      class="mx-2"
      color="primary"
      v-if="selectionable"
      v-model="selectedNotification"
      @click.stop="selectNotification"
    />

    <div class="ma-3">
      <div
        v-if="value.data.title"
        class="noti-title"
        :style="{ color: colorOnHeader ? colorOnHeader : 'black' }"
      >
        <v-icon v-if="!viewed" class="mr-2" x-small color="success"
          >circle</v-icon
        >
        {{ value.data.title }}
      </div>
      <div
        v-if="value.data.body"
        class="noti-body"
        :style="{
          color: colorOnHeader ? colorOnHeader : 'black',
        }"
        v-html="value.data.body"
      ></div>
    </div>
    <div v-if="value.data.sending_time" class="sending_time text--md">
      {{ parseNotificationTime }}
    </div>

    <div class="top-right" @click.stop>
      <slot />
    </div>
  </div>
</template>

<script>
import DateUtil from "@/flit2go-web-core/util/dateUtil";
import { mapGetters } from "vuex";

export default {
  name: "notification-elem-list",
  props: {
    value: Object,
    viewed: {
      type: Boolean,
      default: false,
    },
    formatTime: { type: Boolean, required: false, default: false },
    selectionable: {
      type: Boolean,
      default: false,
      required: false,
    },
    colorOnHeader: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      spriteUrl: require("@/flit2go-web-core/assets/orion-svg-sprite.svg"),
      DateUtil: DateUtil,
      parseNotificationTime: null,
      selectedNotification: false,
    };
  },
  watch: {
    formatTime() {
      if (this.formatTime) this.setNotificationTime();
    },
  },
  computed: {
    ...mapGetters({
      ownerColors: "auth/getOwnerColors",
    }),
  },
  methods: {
    redirecToAction() {
      this.$emit("clickNotification");
      const relativeUrl = this.value.data.click_action.split("#")[1];
      this.remove();
      this.$router.push({ path: relativeUrl });
    },
    redirecToActionNewWindow() {
      window.open(`#${this.value.data.click_action.split("#")[1]}`, "_blank");
    },
    remove() {
      this.$emit("remove");
    },

    selectNotification() {
      this.$emit("selected", this.value.id);
    },

    setNotificationTime() {
      this.parseNotificationTime = DateUtil.formatNotificationsDate(
        this.$PageUtils.getLanguageSplitted(this.$i18n.locale)[1],
        parseInt(this.value.data.sending_time)
      );
    },
  },
  mounted() {
    if (this.value) this.setNotificationTime();
  },
};
</script>

<style lang="scss" scoped>
.notification-elem-list {
  position: relative;
  width: 100%;
  min-height: 90px;
  border-bottom: solid 1px lightgrey;
  color: lightgrey;
  cursor: pointer;
  padding: 5px 0 5px 0;
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  align-items: center;

  .noti-title {
    font-weight: bold;
  }

  .noti-body {
    margin-bottom: 5px;
  }

  &.viewed {
    .noti-title {
      font-weight: normal;
      color: lightgrey !important;
    }
    .noti-body {
      color: lightgrey !important;
    }
  }

  &.viewed {
    .noti-icon {
      stroke: lightgrey;
    }
  }

  &.selectedNoti {
    background-color: rgba(34, 30, 30, 0.034);

    .sending_time {
      position: absolute;
      bottom: 0px;
      right: 5px;
      color: white;
    }
  }

  .noti-icon {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 5px 5px 5px 0;
    width: 50px;
    height: 40px;
    padding: 10px;
  }

  .sending_time {
    position: absolute;
    bottom: 0px;
    right: 5px;
    color: lightgrey;
  }

  .top-right {
    position: absolute;
    top: 0px;
    right: 0px;
  }
}
</style>
